import { syncIconCardStackOffset } from "../shared/icon-card-offset.js";

document.addEventListener("DOMContentLoaded", function () {
  const slidingCardSwipers = document.querySelectorAll(
    ".sliding-cards-new-white .card-swiper",
  );
  const DESKTOP_SLIDES = 3;

  if (slidingCardSwipers.length === 0) {
    return;
  }

  slidingCardSwipers.forEach((cardSwiper) => {
    const swiperId = cardSwiper.dataset.unique;
    const slideCount = cardSwiper.querySelectorAll(".swiper-slide").length;
    const shouldLoop = slideCount > DESKTOP_SLIDES;
    const controlsEl = document.querySelector(
      `.sliding-cards-new-white .swiper-controls[data-controls=${swiperId}]`,
    );
    const prevEl = controlsEl?.querySelector(".prev");
    const nextEl = controlsEl?.querySelector(".next");
    const section = cardSwiper.closest(".sliding-cards-new-white");
    const wrappers = section?.querySelectorAll(".inner-wrapper") || [];
    const iconImages = section?.querySelectorAll(".icon-area img") || [];
    let layoutSyncFrame = null;

    function syncLayout() {
      syncIconCardStackOffset(section, wrappers, {
        uniformHeightProperty: "--sliding-card-uniform-height",
        offsetProperty: "--sliding-card-icon-offset",
      });
    }

    function scheduleLayoutSync() {
      if (layoutSyncFrame) {
        cancelAnimationFrame(layoutSyncFrame);
      }

      layoutSyncFrame = requestAnimationFrame(() => {
        syncLayout();
        layoutSyncFrame = null;
      });
    }

    const servicesSwiper = new Swiper(cardSwiper, {
      loop: shouldLoop,
      slidesPerView: 1,
      spaceBetween: 16,
      autoplay: false,
      allowTouchMove: slideCount > 1,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed: 800,
      navigation:
        prevEl && nextEl
          ? {
              nextEl,
              prevEl,
            }
          : undefined,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        init(swiper) {
          updateControls(swiper, controlsEl);
          scheduleLayoutSync();
        },
        breakpoint(swiper) {
          updateControls(swiper, controlsEl);
          scheduleLayoutSync();
        },
        resize(swiper) {
          updateControls(swiper, controlsEl);
          scheduleLayoutSync();
        },
        update(swiper) {
          updateControls(swiper, controlsEl);
          scheduleLayoutSync();
        },
        lock(swiper) {
          updateControls(swiper, controlsEl);
        },
        unlock(swiper) {
          updateControls(swiper, controlsEl);
        },
      },
    });

    updateControls(servicesSwiper, controlsEl);
    scheduleLayoutSync();
    iconImages.forEach((image) => {
      if (image.complete) return;

      image.addEventListener("load", scheduleLayoutSync, { once: true });
    });
    window.addEventListener("load", scheduleLayoutSync);
    window.addEventListener("resize", scheduleLayoutSync);
  });
});

function updateControls(swiper, controlsEl) {
  if (!swiper || !controlsEl) {
    return;
  }

  controlsEl.classList.toggle("is-hidden", swiper.isLocked);
}
